import Vue from 'vue'
import Dialog from '@/components/Dialog.vue'
let loadingVM = null

const DialogHelper = {
  showModal (context, { message, ok, cancel, subject }) {
    this.endLoadingFullScreen()
    let DialogVM = Vue.extend(Dialog)
    let vm = new DialogVM({
      parent: context,
      propsData: {
        dialogType: 'unknown',
        subject: subject || '無題',
        message: message,
        onPrimary () {
          ok()
          vm.close()
        },
        onSecondary () {
          if(cancel) cancel()
          vm.close()
        },
      }
    })
    vm.show()
  },
  showModalSync (context, { message, subject }) {
    return new Promise((resolve) => {
      this.endLoadingFullScreen()
      let DialogVM = Vue.extend(Dialog)
      let vm = new DialogVM({
        parent: context,
        propsData: {
          dialogType: 'unknown',
          subject: subject || '無題',
          message: message,
          onPrimary() {
            vm.close()
            resolve(true)
          },
          onSecondary() {
            vm.close()
            resolve(false)
          },
        }
      })
      vm.show()
    })
  },
  modalConfirm (context, { message, ok, cancel, nameList, subject }) {
    this.endLoadingFullScreen()
    let DialogVM = Vue.extend(Dialog)
    let vm = new DialogVM({
      parent: context,
      propsData: {
        dialogType: 'confirm',
        subject: subject || null,
        message: message,
        nameList: nameList || null,
        onPrimary () {
          ok()
          vm.close()
        },
        onSecondary () {
          if(cancel) cancel()
          vm.close()
        },
      }
    })
    vm.show()
  },
  modalConfirmSync (context, { message, nameList, subject }) {
    return new Promise((resolve) => {
      this.endLoadingFullScreen()
      let DialogVM = Vue.extend(Dialog)
      let vm = new DialogVM({
        parent: context,
        propsData: {
          dialogType: 'confirm',
          subject: subject || null,
          message: message,
          nameList: nameList || null,
          onPrimary() {
            vm.close()
            resolve(true)
          },
          onSecondary() {
            vm.close()
            resolve(false)
          },
        }
      })
      vm.show()
    })
  },
  modalInfo (context, { message, ok, subject }) {
    this.endLoadingFullScreen()
    let DialogVM = Vue.extend(Dialog)
    let vm = new DialogVM({
      parent: context,
      propsData: {
        dialogType: 'info',
        subject: subject || null,
        message: message,
        onPrimary () {
          if(ok) ok()
          vm.close()
        },
      }
    })
    vm.show()
  },
  modalInfoSync (context, { message, subject }) {
    return new Promise((resolve) => {
      this.endLoadingFullScreen()
      let DialogVM = Vue.extend(Dialog)
      let vm = new DialogVM({
        parent: context,
        propsData: {
          dialogType: 'info',
          subject: subject || null,
          message: message,
          onPrimary() {
            vm.close()
            resolve(true)
          },
        }
      })
      vm.show()
    })
  },
  modalError (context, { message, ok, subject }) {
    this.endLoadingFullScreen()
    let DialogVM = Vue.extend(Dialog)
    let vm = new DialogVM({
      parent: context,
      propsData: {
        dialogType: 'error',
        subject: subject || null,
        message: message,
        onPrimary () {
          if(ok) ok()
          vm.close()
        },
      }
    })
    vm.show()
  },
  modalErrorSync (context, { message, subject }) {
    return new Promise((resolve) => {
      this.endLoadingFullScreen()
      let DialogVM = Vue.extend(Dialog)
      let vm = new DialogVM({
        parent: context,
        propsData: {
          dialogType: 'error',
          subject: subject || null,
          message: message,
          onPrimary() {
            vm.close()
            resolve(true)
          },
        }
      })
      vm.show()
    })
  },
  modalWarning (context, { message, ok, cancel, subject }) {
    this.endLoadingFullScreen()
    let DialogVM = Vue.extend(Dialog)
    let vm = new DialogVM({
      parent: context,
      propsData: {
        dialogType: 'warn',
        subject: subject || null,
        message: message,
        onPrimary () {
          if(ok) ok()
          vm.close()
        },
        onSecondary () {
          if(cancel) cancel()
          vm.close()
        },
      }
    })
    vm.show()
  },
  modalWarningSync (context, { message, subject }) {
    return new Promise((resolve) => {
      this.endLoadingFullScreen()
      let DialogVM = Vue.extend(Dialog)
      let vm = new DialogVM({
        parent: context,
        propsData: {
          dialogType: 'warn',
          subject: subject || null,
          message: message,
          onPrimary() {
            vm.close()
            resolve(true)
          },
          onSecondary() {
            vm.close()
            resolve(false)
          },
        }
      })
      vm.show()
    })
  },
  modalAlert (context, { message, ok, subject }) {
    this.endLoadingFullScreen()
    let DialogVM = Vue.extend(Dialog)
    let vm = new DialogVM({
      parent: context,
      propsData: {
        dialogType: 'alert',
        subject: subject || null,
        message: message,
        onPrimary () {
          if(ok) ok()
          vm.close()
        },
      }
    })
    vm.show()
  },
  modalAlertSync (context, { message, subject }) {
    return new Promise((resolve) => {
      this.endLoadingFullScreen()
      let DialogVM = Vue.extend(Dialog)
      let vm = new DialogVM({
        parent: context,
        propsData: {
          dialogType: 'alert',
          subject: subject || null,
          message: message,
          onPrimary() {
            vm.close()
            resolve(true)
          },
        }
      })
      vm.show()
    })
  },
  modalChooser (context, { message, list, choose, subject }) {
    this.endLoadingFullScreen()
    let DialogVM = Vue.extend(Dialog)
    let vm = new DialogVM({
      parent: context,
      propsData: {
        dialogType: 'choose',
        subject: subject || null,
        message: message,
        nameList: list,
        onPrimary (index) {
          choose(index)
          vm.close()
        },
      }
    })
    vm.show()
  },
  modalChooserSync (context, { message, list, subject }) {
    return new Promise((resolve) => {
      this.endLoadingFullScreen()
      let DialogVM = Vue.extend(Dialog)
      let vm = new DialogVM({
        parent: context,
        propsData: {
          dialogType: 'choose',
          subject: subject || null,
          message: message,
          nameList: list,
          onPrimary(index) {
            vm.close()
            resolve(index)
          },
        }
      })
      vm.show()
    })
  },
  modalAsk (context, { message, ok, cancel, maxLength, placeholder, defaultText, subject }) {
    this.endLoadingFullScreen()
    let DialogVM = Vue.extend(Dialog)
    let vm = new DialogVM({
      parent: context,
      propsData: {
        dialogType: 'ask',
        subject: subject || null,
        askMaxLength: maxLength || 0,
        askPlaceholder: placeholder || null,
        askDefText: defaultText,
        message: message,
        onPrimary (okText) {
          ok(okText)
          vm.close()
        },
        onSecondary () {
          if (cancel) cancel()
          vm.close()
        },
      }
    })
    vm.show()
  },
  modalAskSync (context, { message, maxLength, placeholder, defaultText, subject }) {
    return new Promise((resolve) => {
      this.endLoadingFullScreen()
      let DialogVM = Vue.extend(Dialog)
      let vm = new DialogVM({
        parent: context,
        propsData: {
          dialogType: 'ask',
          subject: subject || null,
          askMaxLength: maxLength || 0,
          askPlaceholder: placeholder || null,
          askDefText: defaultText,
          message: message,
          onPrimary(okText) {
            vm.close()
            resolve(okText)
          },
          onSecondary() {
            vm.close()
            resolve(null)
          },
        }
      })
      vm.show()
    })
  },
  loadingFullScreen(context,type,signColor,{message, progressInit, messageColor, messageBackColor, progressbarColor, progressBackColor} = {}) {
    this.endLoadingFullScreen()
    let DialogVM = Vue.extend(Dialog)
    let typeStr = 'loading0'
    if (!isNaN(type)) {
      type = Number(type)
      if ((type >= 0) && (type <=4)) typeStr = 'loading' + type
    }
    let vm = new DialogVM({
      parent: context,
      propsData: {
        dialogType: typeStr,
        loadingFG: signColor || '#FFFFFF',
        // loadingAddColors: {
        progMsgColor:     messageColor || '#000000',
        progMsgBackColor: messageBackColor || 'rgba(255, 255, 255, 0.3)',
        progBarColor:     progressbarColor || '#84BBFF',
        progBarBackColor: progressBackColor || '#EEEEEE',
        // },
      }
    })
    vm.show()
    loadingVM = vm
    vm.loadingMessageSet(message || "")
    vm.loadingProgressSet(progressInit || null)
  },
  messageForLoadingFS(progMsg) {
    if (loadingVM) {
      loadingVM.loadingMessageSet(progMsg)
    }
  },
  progressBarForLoadingFS(prog) {
    if (loadingVM) {
      if (prog !== null) {
        if (prog < 0) {
          prog = 0
        } else {
          if (prog > 1) { prog = 1 }
        }
      }
      loadingVM.loadingProgressSet(prog)
    }
  },
  isNowLoading() {
    return loadingVM !== null
  },
  endLoadingFullScreen() {
    if (loadingVM) {
      loadingVM.close()
      loadingVM = null
    }
  },
}
export default DialogHelper;